export const ModelStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  DONE: "done",
  REJECTED: "rejected",
  DELIVERED: "delivered",
};

export const modelStatusInfo = {
  pending: { label: "En attente", class: "bg-warning" },
  approved: { label: "Approuvé", class: "bg-info" },
  done: { label: "Terminé", class: "bg-success" },
  rejected: { label: "Rejeté", class: "bg-danger" },
  delivered: { label: "Livré", class: "bg-dark" },
};


export default { ModelStatus, modelStatusInfo };
